<div class="plans-container">
  <!-- Header -->
  <div class="header">
    <h1>Choose plan</h1>
    <!-- Tab Navigation for Personal Plans and Institutional Settings -->
    <div class="md-tabs">
      <div class="md-tab" [class.is-active]="selectedTabIndex() === 0" (click)="switchTab('personal')">Personal plans</div>
      <div class="md-tab" [class.is-active]="selectedTabIndex() === 1" (click)="switchTab('settings')">Institutional settings</div>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="licenseDataService.isLoading() && selectedTabIndex() < 2">
    <div class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
    <div class="loading-message">
      <h3>Loading pricing plans...</h3>
      <p>Fetching the latest pricing and plan information from our servers.</p>
    </div>
  </div>

  <!-- Error State -->
  <div class="error-container" *ngIf="!licenseDataService.isLoading() && licenseDataService.error() && selectedTabIndex() < 2">
    <div class="error-message">
      <mat-icon class="error-icon">warning</mat-icon>
      <h3>Unable to load current pricing</h3>
      <p>We're having trouble loading the latest pricing information. Please try again later.</p>
    </div>
  </div>

  <!-- Personal Plans Tab -->
  <div *ngIf="selectedTabIndex() === 0 && !licenseDataService.isLoading()">
    <!-- Plans Grid -->
    <div class="plans-grid" data-plans="personal">
      <!-- Free Plan - Current -->
      <div class="plan-card plan-card--current" *ngIf="shouldShowCurrentPlanIndicators() && isFreePlanActive()">
        <span class="md-chip md-chip--current">Current plan</span>

        <div class="plan-icon">
          <img src="/assets/plan-images/memowl-free.avif" alt="Free Plan" loading="lazy" class="pricing-image">
        </div>

        <h2 class="plan-title">Free</h2>

        <p class="plan-subtitle" *ngIf="authService.isAuthenticated() && !licenseDataLoaded()" style="color: #9ca3af;">
          <mat-spinner diameter="16" style="display: inline-block; vertical-align: middle; margin-right: 8px;"></mat-spinner>
          <span style="vertical-align: middle;">Checking your subscription...</span>
        </p>

        <p class="plan-subtitle" *ngIf="licenseDataLoaded()">
          Everything you need to start your research and collaborate on 1 project.
        </p>

        <div class="plan-price-row">
          <span class="plan-price">$0</span>
          <span class="plan-interval">/ monthly</span>
        </div>

        <div class="features">
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">Unlimited local projects</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">1 cloud or team project*</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">1 MB cloud storage</span>
          </div>
          <div class="feature feature--off">
            <span class="feature-icon" style="color: #F44336;">close</span>
            <span class="feature-text">Support</span>
          </div>
          <div class="feature feature--off">
            <span class="feature-icon" style="color: #F44336;">close</span>
            <span class="feature-text">File attachments</span>
          </div>
        </div>

        <!-- Registration notice for non-authenticated users -->
        <div class="registration-notice" *ngIf="!authService.isAuthenticated()">
          <mat-icon class="auth-icon">person_add</mat-icon>
          <span>Sign up or <strong>sign in</strong> to access the free tier</span>
        </div>
      </div>

      <!-- Free Plan - Not Current (for comparison) -->
      <div class="plan-card" *ngIf="!shouldShowCurrentPlanIndicators() || !isFreePlanActive()">
        <div class="plan-icon">
          <img src="/assets/plan-images/memowl-free.avif" alt="Free Plan" loading="lazy" class="pricing-image">
        </div>

        <h2 class="plan-title">Free</h2>

        <p class="plan-subtitle">
          Everything you need to start your research and collaborate on 1 project.
        </p>

        <div class="plan-price-row">
          <span class="plan-price">$0</span>
          <span class="plan-interval">/ monthly</span>
        </div>

        <div class="features">
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">Unlimited local projects</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">1 cloud or team project*</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">1 MB cloud storage</span>
          </div>
          <div class="feature feature--off">
            <span class="feature-icon" style="color: #F44336;">close</span>
            <span class="feature-text">Support</span>
          </div>
          <div class="feature feature--off">
            <span class="feature-icon" style="color: #F44336;">close</span>
            <span class="feature-text">File attachments</span>
          </div>
        </div>

        <!-- Subscribe section for free plan -->
        <div class="subscribe-section">
          <!-- Show downgrade info if user is authenticated and has a paid plan -->
          <div class="tier-info-notice" *ngIf="authService.isAuthenticated() && licenseDataLoaded() && !isFreePlanCurrent()">
            <mat-icon class="info-icon">info</mat-icon>
            <span>You have an active subscription. Cancel it to switch to Free plan.</span>
          </div>

          <!-- Show sign-in notice for non-authenticated users -->
          <div class="auth-notice" *ngIf="!authService.isAuthenticated()">
            <mat-icon class="auth-icon">account_circle</mat-icon>
            <span>Sign up or <strong>sign in</strong> to access the free tier</span>
          </div>
        </div>
      </div>

      <!-- First Plan (Essential - Dynamic) -->
      <div class="plan-card plan-card--recommended" *ngIf="firstPlan()" [class.plan-card--current]="shouldShowCurrentPlanIndicators() && isFirstPlanCurrent()">
        <span class="md-chip md-chip--recommended" *ngIf="!shouldShowCurrentPlanIndicators() || !isFirstPlanCurrent()">Recommended</span>
        <span class="md-chip md-chip--current" *ngIf="shouldShowCurrentPlanIndicators() && isFirstPlanCurrent()">Current plan</span>

        <div class="plan-icon">
          <img src="/assets/plan-images/memowl-essential.avif" alt="Essential Plan" loading="lazy" class="pricing-image">
        </div>

        <h2 class="plan-title">{{ firstPlanName() }}</h2>

        <p class="plan-subtitle" *ngIf="authService.isAuthenticated() && !licenseDataLoaded()" style="color: #9ca3af;">
          <mat-spinner diameter="16" style="display: inline-block; vertical-align: middle; margin-right: 8px;"></mat-spinner>
          <span style="vertical-align: middle;">Checking your subscription...</span>
        </p>

        <p class="plan-subtitle" *ngIf="shouldShowCurrentPlanIndicators() && isFirstPlanCurrent()" style="color: #4caf50; font-weight: 600;">
          Your active subscription
        </p>

        <p class="plan-subtitle" *ngIf="(!shouldShowCurrentPlanIndicators() || !isFirstPlanCurrent()) && (licenseDataLoaded() || !authService.isAuthenticated())">
          Put your teams to work, focus on projects, not quotas.
        </p>

        <!-- Price with billing toggle -->
        <div class="plan-price-row" *ngIf="firstPlanPriceDisplay() !== null">
          <span class="plan-price">{{ firstPlanPriceDisplay() }}</span>
          <span class="plan-interval">/ {{ currentBillingCycle() }}ly</span>
        </div>
        <div class="plan-price-row loading-price" *ngIf="firstPlanPriceDisplay() === null">
          <span class="loading-text">Loading pricing...</span>
        </div>

        <!-- Billing Toggle for First Plan (hide for current plan) -->
        <div class="billing-toggle" *ngIf="!shouldShowCurrentPlanIndicators() || !isFirstPlanCurrent()">
          <button class="billing-toggle__btn" [class.is-active]="currentBillingCycle() === 'month'" (click)="setBillingCycle('month')">
            Monthly
          </button>
          <button class="billing-toggle__btn" [class.is-active]="currentBillingCycle() === 'year'" (click)="setBillingCycle('year')">
            Annually
          </button>
        </div>

        <div class="features">
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">Unlimited functionality</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">Unlimited local projects</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text"><strong>5</strong> cloud or team projects*</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text"><strong>100 MB</strong> cloud storage</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">File attachments</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">Support within 2 workdays</span>
          </div>
        </div>

        <!-- Institutional Licenses Info -->
        <div class="institutional-info-section" *ngIf="authService.isAuthenticated() && getInstitutionalLicensesForPlan(firstPlanName()).length > 0">
          <div class="institutional-info-header">
            <mat-icon class="info-icon">school</mat-icon>
            <span>Provided by your institution</span>
          </div>
          <ul class="institutional-list">
            <li *ngFor="let inst of getInstitutionalLicensesForPlan(firstPlanName())">
              {{ inst.groupInfo?.name || inst.name || 'Unknown Institution' }}
            </li>
          </ul>
          <p class="institutional-note">You already have access to this plan via the institutions above.</p>
        </div>

        <!-- Subscribe button -->
        <div class="subscribe-section">
          <!-- Show subscribe button when applicable -->
          <button
            *ngIf="showSubscribeFirstPlan()"
            class="md-btn md-btn--contained"
            [class.disabled]="!authService.isAuthenticated() || firstPlanPriceDisplay() === null || !licenseDataLoaded()"
            [disabled]="!authService.isAuthenticated() || firstPlanPriceDisplay() === null || !licenseDataLoaded()"
            (click)="selectPlan(firstPlan()!)">
            <span class="material-icons" aria-hidden="true">upgrade</span>
            <span *ngIf="authService.isAuthenticated() && licenseDataLoaded() && firstPlanPriceDisplay() !== null">Upgrade</span>
            <span *ngIf="!authService.isAuthenticated()">SIGN IN REQUIRED</span>
            <span *ngIf="authService.isAuthenticated() && !licenseDataLoaded()">CHECKING LICENSE...</span>
            <span *ngIf="authService.isAuthenticated() && licenseDataLoaded() && firstPlanPriceDisplay() === null">LOADING PRICING...</span>
          </button>

          <!-- Show current plan message -->
          <div class="tier-info-notice" style="background: #e8f5e9; border-left-color: #4caf50;" *ngIf="shouldShowCurrentPlanIndicators() && isFirstPlanCurrent()">
            <mat-icon class="info-icon" style="color: #4caf50;">check_circle</mat-icon>
            <span style="color: #2e7d32;">This is your current plan</span>
          </div>

          <!-- Show info message if plan is at or below current tier -->
          <div class="tier-info-notice" *ngIf="authService.isAuthenticated() && licenseDataLoaded() && !showSubscribeFirstPlan() && !isFirstPlanCurrent()">
            <mat-icon class="info-icon">info</mat-icon>
            <span>You already have a higher tier subscription</span>
          </div>

          <!-- Auth notice for non-authenticated users -->
          <div class="auth-notice" *ngIf="!authService.isAuthenticated() && showSubscribeFirstPlan()">
            <mat-icon class="auth-icon">account_circle</mat-icon>
            <span>Please <strong>sign in</strong> to subscribe to this plan</span>
          </div>
        </div>
      </div>

      <!-- Second Plan (Professional - Dynamic) -->
      <div class="plan-card" *ngIf="secondPlan()" [class.plan-card--current]="shouldShowCurrentPlanIndicators() && isSecondPlanCurrent()">
        <span class="md-chip md-chip--current" *ngIf="shouldShowCurrentPlanIndicators() && isSecondPlanCurrent()">Current plan</span>

        <div class="plan-icon">
          <img src="/assets/plan-images/memowl-professional.avif" alt="Professional Plan" loading="lazy" class="pricing-image">
        </div>

        <h2 class="plan-title">{{ secondPlanName() }}</h2>

        <p class="plan-subtitle" *ngIf="authService.isAuthenticated() && !licenseDataLoaded()" style="color: #9ca3af;">
          <mat-spinner diameter="16" style="display: inline-block; vertical-align: middle; margin-right: 8px;"></mat-spinner>
          <span style="vertical-align: middle;">Checking your subscription...</span>
        </p>

        <p class="plan-subtitle" *ngIf="shouldShowCurrentPlanIndicators() && isSecondPlanCurrent()" style="color: #4caf50; font-weight: 600;">
          Your active subscription
        </p>

        <p class="plan-subtitle" *ngIf="(!shouldShowCurrentPlanIndicators() || !isSecondPlanCurrent()) && (licenseDataLoaded() || !authService.isAuthenticated())">
          For labs, teams and large reviews.
        </p>

        <!-- Price with billing toggle -->
        <div class="plan-price-row" *ngIf="secondPlanPriceDisplay() !== null">
          <span class="plan-price">{{ secondPlanPriceDisplay() }}</span>
          <span class="plan-interval">/ {{ currentBillingCycle() }}ly</span>
        </div>
        <div class="plan-price-row loading-price" *ngIf="secondPlanPriceDisplay() === null">
          <span class="loading-text">Loading pricing...</span>
        </div>

        <!-- Billing Toggle for Second Plan (hide for current plan) -->
        <div class="billing-toggle" *ngIf="!shouldShowCurrentPlanIndicators() || !isSecondPlanCurrent()">
          <button class="billing-toggle__btn" [class.is-active]="currentBillingCycle() === 'month'" (click)="setBillingCycle('month')">
            Monthly
          </button>
          <button class="billing-toggle__btn" [class.is-active]="currentBillingCycle() === 'year'" (click)="setBillingCycle('year')">
            Annually
          </button>
        </div>

        <div class="features">
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">Unlimited functionality</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">Unlimited local projects</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text"><strong>1000</strong> cloud or team projects*</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text"><strong>10 GB</strong> cloud storage</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">File attachments</span>
          </div>
          <div class="feature">
            <span class="feature-icon" style="color: #00C853;">check</span>
            <span class="feature-text">Premium support</span>
          </div>
        </div>

        <!-- Institutional Licenses Info -->
        <div class="institutional-info-section" *ngIf="authService.isAuthenticated() && getInstitutionalLicensesForPlan(secondPlanName()).length > 0">
          <div class="institutional-info-header">
            <mat-icon class="info-icon">school</mat-icon>
            <span>Provided by your institution</span>
          </div>
          <ul class="institutional-list">
            <li *ngFor="let inst of getInstitutionalLicensesForPlan(secondPlanName())">
              {{ inst.groupInfo?.name || inst.name || 'Unknown Institution' }}
            </li>
          </ul>
          <p class="institutional-note">You already have access to this plan via the institutions above.</p>
        </div>

        <!-- Subscribe button -->
        <div class="subscribe-section">
          <!-- Show subscribe button when applicable -->
          <button
            *ngIf="showSubscribeSecondPlan()"
            class="md-btn md-btn--contained"
            [class.disabled]="!authService.isAuthenticated() || secondPlanPriceDisplay() === null || !licenseDataLoaded()"
            [disabled]="!authService.isAuthenticated() || secondPlanPriceDisplay() === null || !licenseDataLoaded()"
            (click)="selectPlan(secondPlan()!)">
            <span class="material-icons" aria-hidden="true">upgrade</span>
            <span *ngIf="authService.isAuthenticated() && licenseDataLoaded() && secondPlanPriceDisplay() !== null">Upgrade</span>
            <span *ngIf="!authService.isAuthenticated()">SIGN IN REQUIRED</span>
            <span *ngIf="authService.isAuthenticated() && !licenseDataLoaded()">CHECKING LICENSE...</span>
            <span *ngIf="authService.isAuthenticated() && licenseDataLoaded() && secondPlanPriceDisplay() === null">LOADING PRICING...</span>
          </button>

          <!-- Show current plan message -->
          <div class="tier-info-notice" style="background: #e8f5e9; border-left-color: #4caf50;" *ngIf="shouldShowCurrentPlanIndicators() && isSecondPlanCurrent()">
            <mat-icon class="info-icon" style="color: #4caf50;">check_circle</mat-icon>
            <span style="color: #2e7d32;">This is your current plan</span>
          </div>

          <!-- Show info message if plan is at or below current tier -->
          <div class="tier-info-notice" *ngIf="authService.isAuthenticated() && licenseDataLoaded() && !showSubscribeSecondPlan() && !isSecondPlanCurrent()">
            <mat-icon class="info-icon">info</mat-icon>
            <span>You already have a higher tier subscription</span>
          </div>

          <!-- Auth notice for non-authenticated users -->
          <div class="auth-notice" *ngIf="!authService.isAuthenticated() && showSubscribeSecondPlan()">
            <mat-icon class="auth-icon">account_circle</mat-icon>
            <span>Please <strong>sign in</strong> to subscribe to this plan</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Asterisk note -->
    <p class="asterisk">* Cloud / team projects count per workspace. Storage pooled.</p>
  </div>

  <!-- Institutional Settings Tab -->
  <div *ngIf="selectedTabIndex() === 1">
    <div class="institutional-settings-content">
      <app-institutional-settings 
        [institutionalLicenses]="institutionalLicenses()"
        [registeredEmails]="registeredEmails()"
        (listChanged)="loadUserLicense()">
      </app-institutional-settings>
    </div>
  </div>
</div>
